import { ReactComponent as Icon } from "../icons/calendar2.svg";

const CalendarIcon = ({color, wth}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, marginTop: "3px"})} />
    </div>
  );
};

export default CalendarIcon;